// extracted by mini-css-extract-plugin
export default {"wrapperIcon":"wY3H7","disabled":"ctJcn","wrapper":"bnHpr","selected":"NEDAv","iconCheck":"zd6xO","title":"zy9O0","icon":"VZfsM"};